var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYtIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C20B1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.244 12.1514C20.7767 12.1544 22.1096 12.1673 23.5264 12.2242L24.0292 12.2461C25.4549 12.313 26.8796 12.4287 27.5869 12.6253C28.5298 12.8907 29.27 13.6629 29.5205 14.6426C29.9195 16.199 29.9694 19.2339 29.9754 19.9692L29.9764 20.1209V20.2945C29.9694 21.0298 29.9195 24.0657 29.5205 25.6211C29.267 26.6038 28.5258 27.377 27.5869 27.6384C26.8796 27.835 25.4549 27.9507 24.0292 28.0176L23.5264 28.0405C22.1096 28.0964 20.7767 28.1103 20.244 28.1123L20.0095 28.1133H19.7551C18.6277 28.1064 13.9127 28.0555 12.4121 27.6384C11.4703 27.3731 10.729 26.6008 10.4786 25.6211C10.0796 24.0647 10.0297 21.0298 10.0237 20.2945V19.9692C10.0297 19.2339 10.0796 16.198 10.4786 14.6426C10.732 13.6599 11.4733 12.8867 12.4131 12.6263C13.9127 12.2082 18.6287 12.1574 19.7561 12.1514H20.244ZM18.0042 16.641V23.6248L23.9903 20.1329L18.0042 16.641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtIcon);
export default __webpack_public_path__ + "static/media/yt_icon.0fb2500e5c97ed536da14fc3bc7277b2.svg";
export { ForwardRef as ReactComponent };